// extracted by mini-css-extract-plugin
export default {"wrapper":"OrphanAck_wrapper__nwSOT","label":"OrphanAck_label__k5y2D"};